"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _StandardProductPageTitle = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/StandardProductPageTitle"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: none;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin: 0 20px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledIcon = (0, _styledComponents.default)(_UIIcon.default).withConfig({
  displayName: "GrowthSuiteTitle__StyledIcon",
  componentId: "sc-10l0adi-0"
})(["font-size:26px;margin:0 30px;", ";"], _responsiveBreakpoints.default.tablet(_templateObject())); //The first block of styles are needed for IE fallback

var StyledFlex = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTitle__StyledFlex",
  componentId: "sc-10l0adi-1"
})(["flex-wrap:wrap;max-width:100%;text-align:center;display:grid;align-items:center;grid-template-columns:repeat(7,auto);grid-row-gap:15px;margin-bottom:20px;", ""], _responsiveBreakpoints.default.tablet(_templateObject2()));

var StyledProductPageTitle = (0, _styledComponents.default)(_StandardProductPageTitle.default).withConfig({
  displayName: "GrowthSuiteTitle__StyledProductPageTitle",
  componentId: "sc-10l0adi-2"
})(["display:inline-flex;"]);

var GrowthSuiteTitle = function GrowthSuiteTitle() {
  return _react.default.createElement(StyledFlex, null, _react.default.createElement(StyledProductPageTitle, {
    className: "m-bottom-0",
    hub: 'crm',
    size: "small"
  }), _react.default.createElement(StyledIcon, {
    className: "growth-suite-icon",
    name: "add"
  }), _react.default.createElement(StyledProductPageTitle, {
    className: "m-bottom-0",
    hub: 'marketing',
    size: "small"
  }), _react.default.createElement(StyledIcon, {
    className: "growth-suite-icon",
    name: "add"
  }), _react.default.createElement(StyledProductPageTitle, {
    className: "m-bottom-0",
    hub: 'sales',
    size: "small"
  }), _react.default.createElement(StyledIcon, {
    className: "growth-suite-icon",
    name: "add"
  }), _react.default.createElement(StyledProductPageTitle, {
    className: "m-bottom-0",
    hub: 'service',
    size: "small"
  }));
};

var _default = GrowthSuiteTitle;
exports.default = _default;
module.exports = exports.default;